// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'

const LabelstatusWrapper = styled.div`
  display: inline-block;
  font-size: ${fontSize.small}px;
  background: ${Colors.grayE};
  color: ${Colors.black};
  border-radius: ${borderRadius}px;
  padding: ${spacing.small}px;
  box-sizing: border-box;
  line-height: 1.2;
  text-align: center;
  ${mediaMin.phone`
    width: 100%;
    padding: ${spacing.small}px;
  `} ${({ fullWidthSp }) =>
    fullWidthSp &&
    css`
      width: 100%;
      padding: ${spacing.small}px;
    `};
`

export type PropTypes = {
  children: any,
  fullWidthSp?: boolean,
}

export default function Labelstatus(props: PropTypes) {
  return (
    <LabelstatusWrapper fullWidthSp={props.fullWidthSp}>
      {props.children}
    </LabelstatusWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/atoms/LabelStatus/index.jsx